import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import { DateRangePicker as DateRangePickerMUI } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { Box, TextField, FormControl } from '@mui/material'

const DateRangePicker = ({ name, control, defaultValue, startLabel, endLabel, maxDate, minDate }) => {
  const labelId = `${name}-label`
  return (
    <FormControl sx={{ width: '100%' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Controller
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ field: { onChange, value } }) => (
            <DateRangePickerMUI
              labelId={labelId}
              value={value}
              onChange={onChange}
              startText={startLabel}
              endText={endLabel}
              maxDate={maxDate}
              minDate={minDate}
              renderInput={(startProps, endProps) => (
                <>
                  <TextField {...startProps} />
                  <Box sx={{ mx: 2 }}> to </Box>
                  <TextField {...endProps} />
                </>
              )}
            />
          )}
        />
      </LocalizationProvider>
    </FormControl>
  )
}

DateRangePicker.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.array,
  control: PropTypes.instanceOf(Object).isRequired,
  startLabel: PropTypes.string,
  endLabel: PropTypes.string,
  maxDate: PropTypes.any,
  minDate: PropTypes.any,
}

DateRangePicker.defaultProps = {
  defaultValue: [null, null],
  startLabel: 'Start Date',
  endLabel: 'End Date',
  maxDate: null,
  minDate: null,
}

export default DateRangePicker
